export const BUILT_IN_ELEMENTS_REQUIRED_PROPERTIES_MAP: Map<string, Set<string>> = new Map([
	[
		"textarea",
		new Set(["value"])
	]
]);